module.exports = __webpack_public_path__ + "static/media/cityBG.b1b3ee8c.png";